import Layout from "@/layout";
export default {
  path: "Commodity",
  component: () => import('@/views/AppMain/index'),
  name: "Commodity",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "商品管理",
    keepAlive: false,
    icon: '1005',
    activeIcon: '1004',
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "CommodityManagement",
      component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityManagement"),
      name: "CommodityManagement",
      meta: {
        title: "商品列表",
        keepAlive: true,
      }
    },
    {
        hidden: false,
        path: "CommodityClassification",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityClassification"),
        name: "CommodityClassification",
        meta: {
          title: "商品分类",
          keepAlive: true,
        }
      },
      {
        hidden: false,
        path: "CommodityUnit",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityUnit"),
        name: "CommodityUnit",
        meta: {
          title: "商品单位",
          keepAlive: true,
        }
      },
      {
        hidden: true,
        path: "CommodityManagementAdd",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityManagementAdd"),
        name: "CommodityManagementAdd",
        meta: {
          title: "商品添加/编辑",
          keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Commodity/CommodityManagement'
        }
      },
      {
        hidden: true,
        path: "CommodityPreSale",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityPreSale"),
        name: "CommodityPreSale",
        meta: {
          title: "预售商品",
          keepAlive: true,
        }
      },
      {
        hidden: true,
        path: "CommodityPreSaleAdd",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityPreSaleAdd"),
        name: "CommodityPreSaleAdd",
        meta: {
          title: "预售商品添加/编辑",
          keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Commodity/CommodityPreSale'
        }
      },
      {
        hidden: true,
        path: "CommodityRecommend",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityRecommend"),
        name: "CommodityRecommend",
        meta: {
          title: "推荐商品",
          keepAlive: false,
        }
      },
      {
        hidden: true,
        path: "CommodityRecommendAdd",
        component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityRecommendAdd"),
        name: "CommodityRecommendAdd",
        meta: {
          title: "添加推荐商品",
          keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Commodity/CommodityRecommend'
        }
      },
  ]
};
